/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExtractionData } from './ExtractionData';
import {
    ExtractionDataFromJSON,
    ExtractionDataFromJSONTyped,
    ExtractionDataToJSON,
    ExtractionDataToJSONTyped,
} from './ExtractionData';
import type { ExtractedDataResponseMetadata } from './ExtractedDataResponseMetadata';
import {
    ExtractedDataResponseMetadataFromJSON,
    ExtractedDataResponseMetadataFromJSONTyped,
    ExtractedDataResponseMetadataToJSON,
    ExtractedDataResponseMetadataToJSONTyped,
} from './ExtractedDataResponseMetadata';

/**
 * Complete extracted data with metadata and hierarchical structure
 * @export
 * @interface ExtractedDataResponse
 */
export interface ExtractedDataResponse {
    /**
     * 
     * @type {ExtractedDataResponseMetadata}
     * @memberof ExtractedDataResponse
     */
    metadata: ExtractedDataResponseMetadata;
    /**
     * 
     * @type {ExtractionData}
     * @memberof ExtractedDataResponse
     */
    data: ExtractionData;
}

/**
 * Check if a given object implements the ExtractedDataResponse interface.
 */
export function instanceOfExtractedDataResponse(value: object): value is ExtractedDataResponse {
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ExtractedDataResponseFromJSON(json: any): ExtractedDataResponse {
    return ExtractedDataResponseFromJSONTyped(json, false);
}

export function ExtractedDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtractedDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'metadata': ExtractedDataResponseMetadataFromJSON(json['metadata']),
        'data': ExtractionDataFromJSON(json['data']),
    };
}

export function ExtractedDataResponseToJSON(json: any): ExtractedDataResponse {
    return ExtractedDataResponseToJSONTyped(json, false);
}

export function ExtractedDataResponseToJSONTyped(value?: ExtractedDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metadata': ExtractedDataResponseMetadataToJSON(value['metadata']),
        'data': ExtractionDataToJSON(value['data']),
    };
}

